import { useActivateCampaignToggle } from 'entities/campaign';
import { ConfirmAction } from 'shared/ui/ConfirmAction';
import type { ContractorGetCampaignModel, ManagerGetCampaignModel } from 'entities/campaign';
import { AlertBox } from 'shared/ui/AlertBox';
import { Button } from 'shared/ui/Button';
import { getDataAutoTestAttributes } from 'shared/lib/data-auto-test';
import { useHidable } from 'shared/lib/hooks';

interface DeactivateCampaignProps {
  campaign: ManagerGetCampaignModel | ContractorGetCampaignModel;
  onSuccessHandler?: () => void;
}

export function DeactivateCampaign({ campaign, onSuccessHandler }: DeactivateCampaignProps) {
  const { isShown, show, hide } = useHidable(false);

  const activateCampaignToggleQuery = useActivateCampaignToggle(campaign.id, onSuccessHandler);
  const title =
    campaign.type === 'appt'
      ? 'Stops the campaign, but it may still receive some appointments that have already started processing.'
      : "Stops the campaign immediately and it won't receive any leads.";

  return (
    <AlertBox
      data-testId="TestId_deactivateCampaign"
      className="mb-8 border-red-100"
    >
      <p className="text-sm text-slate-700">{title}</p>
      {isShown ? (
        <div className="mt-4">
          <ConfirmAction
            cancel={hide}
            confirm={activateCampaignToggleQuery.mutate}
            isConfirmLoading={activateCampaignToggleQuery.isLoading}
          />
        </div>
      ) : (
        <Button
          type="button"
          className="mt-4 w-full"
          onClick={show}
          variant="outline-danger"
          size="medium"
          {...getDataAutoTestAttributes(['button-deactivate-campaign'])}
        >
          Deactivate campaign
        </Button>
      )}
    </AlertBox>
  );
}
